import { postForm } from '@/shared/api/client';

export interface FinesListParams {
  page: number;
  service_id: string;
  name: string;
  bid_id: string;
  status_id: string;
  create_time_from: number | '';
  create_time_to: number | '';
  country_id: string;
}

export function fetchFinesList(params: FinesListParams) {
  return postForm<Record<string, unknown>>('/bid/fines/list/', { ...params });
}
